import { FinancialSummary } from 'src/shared/financial-summary.dto'
import { GrowthRatio } from 'src/shared/growth-ratio'
import { RatioMomentum } from 'src/shared/momentum-ratio'
import { Profile } from 'src/shared/profile.dto'
import { QualityRatio } from 'src/shared/quality-ratio'
import { StockRanksData } from 'src/shared/stock-ranks'
import { ValuationRatio } from 'src/shared/valuation-ratio'

import { RatioGeneral } from './ratios.dto'
import { Sector } from './sectors.dto'

export interface PageData {
  selectedNavIndex: number
  reportName: string
}

export interface Security {
  id: string
  image?: string
  benchmarkIndex: string
  generatedAt: string
  name: string
  ticker: string
  googleExchangeCode: string
  sectors: Sector[]
  countryCode: string
  exchangeCode: string
  ratios: {
    general: RatioGeneral
    momentum: RatioMomentum
    growth: GrowthRatio
    valuation: ValuationRatio
    quality: QualityRatio
  }
  ranks: StockRanksData
}

export interface StockReportData {
  security: Security
  historicalQuotePrice: [number, number][]
  financialSummary: FinancialSummary
  cybertorial: {
    articles: Article[]
  }
  profile: Profile
  news: News[]
  events: {
    upcoming: SecurityEvent[]
    past: SecurityEvent[]
  }
  analystForecast: {
    firstEstimateDate: string
    secondEstimateDate: string
  }
  similar: SimilarSecurity[]
  faqs: FAQ
}

export interface Dividend {
  exDate: string
  payDate: string
  type: string
  dividend: string
}

export interface DividendsReportData {
  security: Security
  dividends: ReadonlyArray<Dividend>
}

export enum SecurityStyle {
  SuperStock = 'Super Stock',
  HighFlyer = 'High Flyer',
  Contrarian = 'Contrarian',
  Turnaround = 'Turnaround',
  SuckerStock = 'Sucker Stock',
  MomentumTrap = 'Momentum Trap',
  ValueTrap = 'Value Trap',
  FallingStar = 'Falling Star',
  Neutral = 'Neutral',
  None = 'n/a',
}

export const WINNING_STYLES: SecurityStyle[] = [
  SecurityStyle.SuperStock,
  SecurityStyle.HighFlyer,
  SecurityStyle.Contrarian,
  SecurityStyle.Turnaround,
]
export const LOSING_STYLES: SecurityStyle[] = [
  SecurityStyle.SuckerStock,
  SecurityStyle.MomentumTrap,
  SecurityStyle.ValueTrap,
  SecurityStyle.FallingStar,
]
export const NEUTRAL_STYLES: SecurityStyle[] = [SecurityStyle.Neutral]

interface Article {
  articleUrl: string
  imageUrl: string
  title: string
  snippet: string
  author: {
    name: string
    username: string
  }
  date: string
}

export interface Index {
  name: string
  id: string
}

export interface News {
  date: string
  title: string
  link: string
  type: string
}

export interface SecurityEvent {
  date: string
  title: string
}

export interface SimilarSecurity {
  name: string
  image?: string
  ticker: string
  countryCode: string
  exchange: {
    code: string
    name: string
    googleExchangeCode: string
  }
}

export interface FAQDirector {
  name: string
  age?: number
  position: string
}

export interface FAQMajorShareholder {
  name: string
  type: string
  percentageOwned: number
  numShares: string
}

export interface FAQ {
  currentYear: number
  tradingAt: string
  marketCap: string
  priceMove365Days: string
  buyOrSell: string
  dividendYield?: string
  trailingDividend: number
  totalDividend: number
  exDividendDate?: string
  nextDividendPayDate?: string
  countryOfListing: string
  exchange: string
  tickerSymbol: string
  style: SecurityStyle
  analystConsensusDiscount: string
  analystConsensusTargetPrice?: string
  epsForecast: string
  relativeStrength: number
  peRatio?: string
  percentageAgainst200DayMovingAverage: string
  directors: FAQDirector[]
  majorShareHolders: FAQMajorShareholder[]
}
